import type {
  HGChangePlayersStatus,
  HgGetPlayersBasedOnStatus
} from '@ps/web-shared-api-types/v0/SwHomeGames';
import { get } from 'lodash';
import type { TableInstance } from 'react-table';

import { useChangePlayerStatus } from '@swf/poker';

export interface SyntheticEvent {
  target: EventTarget & {
    dataset: {
      action: string;
    };
  };
}

const useActionButtons = ({
  tableInstance,
  callbackStatuses,
  memberType
}: {
  tableInstance: TableInstance<object>;
  callbackStatuses: HgGetPlayersBasedOnStatus['statuses'];
  memberType: 'approved' | 'pending' | 'blocked';
}) => {
  const { handleAction } = useChangePlayerStatus(memberType);
  const userIds = tableInstance.selectedFlatRows.map((row) => row?.values.userId);
  const disabled = userIds.length === 0;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const action = get(e, 'target.dataset.action') as HGChangePlayersStatus['action'];

    if (disabled || !action) {
      return;
    }

    tableInstance.setAllFilters([]);
    handleAction({ action, callbackStatuses, userIds });
  };

  return { disabled, handleClick };
};

export default useActionButtons;
